import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'utils/i18n';
import './StylingMock.css';

/**
 * Navigation Component for Styling Mock Pages
 * Provides sidebar navigation between different component showcase pages
 */
const StylingMockNav = ({ currentPath }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navItems = [
    { path: '/styling-mock', label: t('header.navigationGroups.pressKit.items.overview') },
    { path: '/styling-mock/buttons', label: t('header.navigationGroups.pressKit.items.buttons') },
    { path: '/styling-mock/containers', label: t('header.navigationGroups.pressKit.items.containers') },
    { path: '/styling-mock/ui', label: t('header.navigationGroups.pressKit.items.ui') },
    { path: '/styling-mock/typography', label: t('header.navigationGroups.pressKit.items.typography') },
    { path: '/styling-mock/logo', label: t('header.navigationGroups.pressKit.items.logo') },
    { path: '/styling-mock/layouts', label: t('header.navigationGroups.pressKit.items.layouts') },
    { path: '/styling-mock/animations', label: t('header.navigationGroups.pressKit.items.animations') },
    { path: '/styling-mock/navigation', label: 'Navigation' }
  ];

  const handleNavClick = (path) => {
    navigate(path);
  };

  return (
    <nav className="styling-mock-nav">
      <ul className="styling-mock-nav-list">
        {navItems.map((item) => {
          const isActive = currentPath === item.path || 
            (item.path !== '/styling-mock' && currentPath.startsWith(item.path));
          
          return (
            <li key={item.path} className="styling-mock-nav-item">
              <button
                className={`styling-mock-nav-link ${isActive ? 'active' : ''}`}
                onClick={() => handleNavClick(item.path)}
              >
                {item.label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default StylingMockNav;

